"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button"));
var styles_1 = require("./styles");
var Menu_1 = __importDefault(require("../Menu"));
var useLayoutLinks_1 = require("./hooks/useLayoutLinks");
var react_i18next_1 = require("react-i18next");
var Layout_1 = __importDefault(require("../context/Layout"));
var useEnabledPreferredPronouns_1 = require("./hooks/useEnabledPreferredPronouns");
var prism_utilities_1 = require("@octanner/prism-utilities");
var ProfileMenu = function (_a) {
    var _b, _c, _d, _e;
    var logoutUrl = _a.logoutUrl, links = _a.links, handleNavigation = _a.handleNavigation, profileMenuEl = _a.profileMenuEl, setProfileMenuEl = _a.setProfileMenuEl, currentIdentityLoading = _a.currentIdentityLoading;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _f = __read((0, react_1.useContext)(Layout_1.default), 1), currentIdentityQuery = _f[0];
    var currentIdentity = (_b = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _b === void 0 ? void 0 : _b.currentIdentity;
    var customerUuid = (_c = currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.customer) === null || _c === void 0 ? void 0 : _c.customerUuid;
    var enablePronounData = (0, useEnabledPreferredPronouns_1.useEnabledPreferredPronouns)(customerUuid).data;
    var enablePronouns = (_d = enablePronounData === null || enablePronounData === void 0 ? void 0 : enablePronounData.ccWebPreferredPronouns) === null || _d === void 0 ? void 0 : _d.enabled;
    var fullName = (0, prism_utilities_1.getFullName)(currentIdentity, enablePronouns);
    var avatarSrc = (_e = currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.profile) === null || _e === void 0 ? void 0 : _e.avatar;
    var index = links.findIndex(function (_a) {
        var id = _a.id;
        return id === useLayoutLinks_1.MenuLinks.Logout;
    });
    if (index >= 0)
        links.splice(index, 1);
    if (currentIdentityLoading) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.StyledSkeleton, null),
            react_1.default.createElement(styles_1.AvatarSkeleton, { variant: "circular" })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { disableRipple: true, sx: styles_1.buttonFocusOverride, variant: "text", "data-testid": "current-user-name-header", "aria-label": "".concat(fullName, " Profile"), "aria-haspopup": "true", "aria-controls": "profile-menu", "aria-expanded": !!profileMenuEl, onClick: function (e) { return setProfileMenuEl(e.currentTarget); } },
            fullName,
            react_1.default.createElement(styles_1.HeaderAvatar, { src: avatarSrc, alt: fullName, "data-testid": "current-user-avatar-header", size: "sm" })),
        react_1.default.createElement("div", { id: "profile-menu" },
            react_1.default.createElement(Menu_1.default, { id: "profile-menu", anchorEl: profileMenuEl, anchorOrigin: {
                    horizontal: 'right',
                    vertical: 'bottom',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, open: !!profileMenuEl, onClose: function () { return setProfileMenuEl(null); }, MenuListProps: {
                    'aria-labelledby': 'profile-menu',
                }, PaperProps: {
                    style: { minWidth: 200, padding: '0 8px' },
                } },
                links.map(function (_a) {
                    var id = _a.id, translationString = _a.translationString, url = _a.url;
                    return (react_1.default.createElement(styles_1.ProfileMenuItem, { href: url, key: id, "data-testid": "".concat(translationString, "-link"), "aria-label": t("prism-header:".concat(translationString)), "aria-required": "true", onClick: handleNavigation(url), autoFocus: id === useLayoutLinks_1.MenuLinks.Profile }, t("prism-header:".concat(translationString), translationString)));
                }),
                react_1.default.createElement(styles_1.FullWidthDivider, { "aria-hidden": "true" }),
                react_1.default.createElement(styles_1.LogoutMenuItem, { href: logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : '/logout', "data-testid": "logout-link", "aria-label": t('prism-header:logout', 'Logout'), "aria-required": "true", onClick: handleNavigation(logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : '/logout') }, t('prism-header:logout', 'Logout'))))));
};
exports.default = ProfileMenu;
//# sourceMappingURL=ProfileMenu.js.map